import React from 'react';
import { useTranslation } from 'react-i18next';

export const FeatureList: React.FC = () => {
  const { t, ready: translationLoaded } = useTranslation('self-service/packages/package-tiles');

  if (!translationLoaded) {
    return null;
  }

  return (
    <div className="package-tiles__feature-list">
      <h3>{t('featureListHeader')}</h3>
      <ul>
        {(t('featureList', { returnObjects: true }) as string[]).map((feature, index) => (
          <li key={`feature-${index}`}>{feature}</li>
        ))}
      </ul>
    </div>
  );
};
